import _taggedTemplateLiteral from "/codebuild/output/src756613865/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

import styled, { css } from "styled-components";
import { CheckMark } from "../Icons";
import { colors, size, typography } from "../../shared/constants";

var HiddenCheckbox = styled.input.attrs({
  type: "checkbox"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"]))),
    setCheckBoxColors = function setCheckBoxColors(e) {
  return e.checked ? colors.green5 : colors.white;
},
    StyledCheckbox = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  width: 29px;\n  height: 29px;\n  margin: ", ";\n  background: ", ";\n  border-radius: 3px;\n  border: solid 1px ", ";\n  transition: all 300ms;\n  & > svg {\n    visibility: ", ";\n  }\n"])), function (e) {
  return e.border ? "".concat(size.lg, "px ").concat(size.md, "px ").concat(size.lg, "px ").concat(size.lg, "px;") : "".concat(size.lg, "px ").concat(size.md, "px ").concat(size.lg, "px 0;");
}, function (e) {
  return e.disabled ? colors.gray2 : setCheckBoxColors(e);
}, colors.green2, function (e) {
  return e.checked ? "visible" : "hidden";
}),
    CheckboxContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""]))),
    setCheckMarkColors = function setCheckMarkColors(e) {
  return e.color ? e.color : colors.white;
},
    Checkmark = styled(CheckMark)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  width: 20px;\n"])), function (e) {
  return e.disabled ? colors.green3 : setCheckMarkColors(e);
}),
    Label = styled.label(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n"]))),
    LabelText = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: ", ";\n  align-self: center;\n  ", "\n"])), colors.green5, typography.weight.bold, function (_ref) {
  var e = _ref.bodyTextStyle;
  return e && css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      ", "\n    "])), typography.bodyTextSmall);
}),
    LabelContent = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: flex;\n  margin: ", ";\n"])), function (e) {
  return e.border ? "".concat(size.lg, "px ").concat(size.lg, "px ").concat(size.lg, "px ").concat(size.lg, "px;") : "".concat(size.lg, "px ").concat(size.lg, "px ").concat(size.lg, "px 0;");
}),
    Wrapper = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  border: ", ";\n  background-color: ", ";\n  transition: all 400ms;\n  box-shadow: ", ";\n  border-radius: 4px;\n  user-select: none;\n"])), function (e) {
  return e.border ? "solid 1px " + colors.green2 : "none";
}, function (e) {
  return e.border ? e.checked ? colors.green1 : colors.white : "transparent";
}, function (e) {
  return e.border && e.checked ? "0 7px 30px -10px #dce4e5" : "none";
});

export { HiddenCheckbox, StyledCheckbox, CheckboxContainer, Checkmark, Label, LabelText, LabelContent, Wrapper };